import { AlertTitle, Box, Button, Typography } from "@mui/material";
import ErrorBox from "../../../../components/shared/boxes/ErrorBox";

const DataRequiredMessageError = ({ clientId }) => {

    const handleResolveClick = () => {
        if (clientId) {
            window.open(`/resource_places/${clientId}?view_mode=Customer`, "_blank");
        }
    };
    return (
        <Box sx={{ my: 2 }}>
            <ErrorBox
                errorMessage={
                    <>
                        <AlertTitle>
                            O cadastro do cliente selecionado está incompleto.
                        </AlertTitle>
                        <Typography>
                            Para utilizar uma forma de pagamento automática, preencha CPF/CNPJ, E-mail e Telefone
                            do cliente selecionado para essa fatura.
                        </Typography>
                    </>
                }
                action={
                    <Button
                        variant="transparentErrorButton"
                        onClick={handleResolveClick}
                        sx={{ ml: 2 }}
                    >
                        Resolver
                    </Button>
                }
            />
        </Box>
    )
}

export default DataRequiredMessageError;